import { Alert as RBAlert } from 'react-bootstrap';
import { Variant } from 'react-bootstrap/esm/types';

import './Alert.scss';

interface AlertProps {
  icon?: string;
  heading: string;
  variant?: Variant;
}

const Alert = ({ icon, heading, variant = 'primary' }: AlertProps) => {
  return (
    <RBAlert bsPrefix="Alert" variant={variant}>
      <RBAlert.Heading>
        {!!icon && <span className="material-symbols-outlined">{icon}</span>}
        {heading}
      </RBAlert.Heading>
    </RBAlert>
  );
};

export default Alert;
